import React from 'react';
import PropTypes from 'prop-types';
import { Col } from '@cvent/carina/components/Col';
import useTheme from '@cvent/blocks/hooks/useTheme';
import { injectTestId } from '@cvent/nucleus-test-automation';
import Menu from '@cvent/carina/components/Menu';
import Icon from '@components/shared/Icon';

const useStyles = () => {
  return {
    actionButton: {
      backgroundColor: 'transparent',
      cursor: 'pointer',
      border: 'none'
    }
  };
};

export const ApptPanelMenu = ({ menuActions, menuLabel, menuTestId, id }) => {
  const styles = useStyles();
  const theme = useTheme();

  if (menuActions?.length === 0) {
    return null;
  }

  return (
    <Col padding={{ top: 11, bottom: 0, start: 0, end: 0 }} width="content">
      <Menu
        testID={menuTestId}
        placement={'bottom-end'}
        options={menuActions}
        onSelect={option => option.onSelect()}
        trigger={handlePress => (
          <button
            id={id}
            {...injectTestId(`${menuTestId}-button`)}
            css={styles.actionButton}
            onClick={handlePress}
            aria-label={menuLabel}
          >
            <Icon
              name="more-vertical"
              size="lg"
              color={theme.font.color.soft}
              aria-hidden
            />
          </button>
        )}
      />
    </Col>
  );
};

ApptPanelMenu.propTypes = {
  id: PropTypes.string,
  menuActions: PropTypes.arrayOf(PropTypes.object).isRequired,
  menuLabel: PropTypes.string,
  menuTestId: PropTypes.string
};

export default ApptPanelMenu;
